import { api } from './';

interface ApiError {
  response?: {
    data: {
      status: number;
      error?: string;
      message: string;
      path?: string;
      timestamp?: string;
      details?: string[];
    };
    status: number;
    statusText: string;
  };
}

export const inserirMidiaDigital = async (params: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await api.post('/bibliotecaDigital/inserir', params, {headers});
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const inserirNoCdn = async (params: FormData) => {
  try {
    const response = await api.post('/files/upload', params, {
      headers: {
        'Accept': '*/*'
      },
    });
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const editarMidiaDigital = async (id: any, params: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await api.put(`/bibliotecaDigital/editar/${id}`, params, {headers});
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const editarNoCdn = async (params: FormData) => {
  try {
    const response = await api.put('/files/update', params, {
      headers: {
        'Accept': '*/*'
      },
    });
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const deletarMidiaDigital = async (id: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await api.delete(`/bibliotecaDigital/deletar?seqMidia=${id}`, {headers});
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const deletarNoCdn = async (nomeArquivo: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await api.delete(`/files/${nomeArquivo}`, {headers});
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const listarTipoDeMidia = async () => {
  try {
    const response = await api.get(`/bibliotecaDigital/listarTiposMidias`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const obterMidia = async (id: any) => {
  try {
    const response = await api.get(`/bibliotecaDigital/obter/${id}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao obter midia digital';
    throw new Error(errorMessage);
  }
};

export const listarMidias = async (
  pagina: number,
  tamanhoPagina: number,
  dscMidia?: string,
  codMidia?: number,
) => {
  try {
    const params = new URLSearchParams();

    params.append('pagina', pagina.toString());
    params.append('tamanhoPagina', tamanhoPagina.toString());

    if (dscMidia) params.append('dscMidia', dscMidia);
    if (codMidia) params.append('codMidia', codMidia.toString());

    const response = await api.get(`/bibliotecaDigital/listar?${params.toString()}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};